import styled from '@emotion/styled';
import { Typography } from 'antd';
import { type CSSProperties } from 'react';

import { theme } from '../../../../../theme/theme';
import { MeasurePageMainContainer } from '../MeasurePagesSharedComponents';

export const badgeStyle = {
	paddingBlock: '3px',
	paddingInline: '0',
	fontWeight: 'normal',
	maxInlineSize: '236px',
	maxBlockSize: '36px',
	border: 'none',
	inlineSize: 'fit-content',
	blockSize: '18px',
	borderRadius: '2px 0px 0px',
	fontSize: '14px',
	background: 'transparent',
	opacity: '85%',
	lineHeight: '12px',
	textUnderlinePosition: 'from-font',
	textDecorationSkipInk: 'none',
	textAlign: 'center',
	marginBlockEnd: '0px',
} as const satisfies CSSProperties;

export const StyledMoreExpander = styled(Typography.Text)`
	color: ${theme.font.colors.secondary};
	font-weight: ${theme.font.weights[500]};
	font-size: ${theme.font.sizes.sm};
	line-height: 20px;
	padding-inline-start: ${theme.paddings.xxxs};
`;

export const StyledEvidenceList = styled.ul`
	margin-inline-start: 0px;
	padding-inline-start: 18px;
	margin-block-start: 0;
	list-style-type: none;
	padding: 0;
`;

export const StyledEvidenceListItem = styled.li`
	margin-block-end: 12px;
`;

export const StyledInactiveText = styled.li`
	margin-block-end: 12px;
	color: ${theme.font.colors.secondary};
`;

export const StickyQueryPanelContainer = styled.div`
	position: sticky;
	top: 0;
	z-index: 11;
	background-color: white;
	margin: 0;
	padding: 0;
	box-sizing: border-box;
`;

export const NonStickyHeaderContainer = styled.div`
	box-sizing: border-box;
	margin-block: 14px;
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0;
	margin: 0;
	row-gap: 0;
	box-sizing: border-box;

	& > * {
		margin-top: 0;
		margin-bottom: 0;
	}
`;

export const StyledMeasurePageMainContainer = styled(MeasurePageMainContainer)`
	padding-top: 0;
	margin-top: 0;
`;

export const MeasureCountContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 4px;
	white-space: nowrap;
`;

export const StyledText = styled(Typography.Text)`
	white-space: nowrap;
`;
